import React, { useRef, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import { useHistory, useParams } from 'react-router-dom'

import AddScheduleFinishFormProperties from './AddScheduleFinishFormProperties'
import FreightBookingTranslationText from 'src/views/freightbooking/shared/FreightBookingTranslationText'
import ManageScheduleTranslationText from '../ManageScheduleTranslationText'
import pathMap from 'src/paths/PathMap_VesselSchedule'

// const validationSchema = useNewBookingMakeValidationSchema()

const {
  form: { CngViewForm },
  table: { useDefaultNotification }
} = components

function AddScheduleFinishPage({ showNotification }) {
  const { id } = useParams()
  const history = useHistory()
  const { createRecord } = useServices()
  const [loading, setLoading] = useState(false)
  const translatedTextsObject = ManageScheduleTranslationText()

  const {
    success: showSuccessNotification,
    error: showErrorNotification
  } = useDefaultNotification(showNotification)

  function onSubmit(data) {
    console.log('submit', data)
  }

  return (
    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <AddScheduleFinishFormProperties.FormFields
          disabled={false}
          showNotification={showNotification}
          loading={loading}
        />
      }
      formikProps={{
        ...AddScheduleFinishFormProperties.formikProps,
        // validationSchema,
        onSubmit: onSubmit
      }}
    />
  )
}

export default AddScheduleFinishPage
